<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M21.5,4a1.5,1.5,0,0,0-3,0V15.76a.25.25,0,0,1-.427.176L5.06,2.937A1.5,1.5,0,0,0,2.94,5.06L15.969,18.075a.25.25,0,0,1-.177.427H4a1.5,1.5,0,0,0,0,3H19A2.5,2.5,0,0,0,21.5,19Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'arrow-corner-right',
    },
    name: {
      type: String,
      required: false,
      default: 'ArrowCornerRight',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>